module.exports = "/_next/static/images/coin-8f03b84c753e375cc9222a9c646fef3a.svg";